import { render } from "./TabBox.vue?vue&type=template&id=5c0c70d2&scoped=true"
import script from "./TabBox.vue?vue&type=script&lang=ts"
export * from "./TabBox.vue?vue&type=script&lang=ts"

import "./TabBox.vue?vue&type=style&index=0&id=5c0c70d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c0c70d2"

export default script